export enum AffiliateVersions {
	CONCEPT = 'concept',
}

export type AffiliateVersion = AffiliateVersions.CONCEPT;
